import { SET_STAFF } from "../constantes";

const setStaff = (payload) => {
    return{
        type: SET_STAFF,
        payload
    }
};

export default setStaff;